import React from 'react';
import PropTypes from 'prop-types';
import { WithErrorLabel } from '@hobs/components/FormError';
import classnames from 'classnames';
import InputLabel from '../InputLabel';
import Styles from './Dropdown.module.scss';

const Dropdown = ({
  label,
  field,
  value,
  name,
  placeholder,
  noMargin,
  children,
  onChange = () => {},
  disabled,
  large,
  wrapperClass,
  indicationMessage
}) => {
  return (
    <div
      className={classnames(
        Styles['form-item'],
        {
          [Styles['no-margin']]: noMargin
        },
        wrapperClass,
        'stop-drag'
      )}
    >
      {label && (
        <InputLabel indicationMessage={indicationMessage}>{label}</InputLabel>
      )}
      <div
        data-input="dropdown"
        className={classnames(Styles['select'], {
          [Styles.large]: large,
          [Styles.disabled]: disabled
        })}
      >
        <select
          disabled={disabled}
          placeholder={placeholder}
          name={name}
          value={value}
          {...field}
          onChange={event => {
            onChange(event);
            if (field && field.onChange) {
              field.onChange(event);
            }
          }}
        >
          {children}
        </select>
        <span tabIndex="-1" className={Styles['arrow']} />
      </div>
    </div>
  );
};

Dropdown.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number
  ]),
  name: PropTypes.string,
  disabled: PropTypes.bool,
  noMargin: PropTypes.bool,
  large: PropTypes.bool,
  wrapperClass: PropTypes.string,
  form: PropTypes.object,
  field: PropTypes.object,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  type: PropTypes.oneOf(['text', 'password']),
  label: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.string
  ]),
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.string
  ]),
  indicationMessage: PropTypes.object
};

export default WithErrorLabel(Dropdown);
